import { defineStore } from 'pinia';

export interface GlobalState {
  showDropdown: boolean;
  showDropdownId: string;
}

export interface DropdownInput {
  status: boolean;
  id: string;
}

export interface GlobalActions {
  setShowDropdown: (this: any, payload: DropdownInput) => void;
}

export const useCoreStore = defineStore({
  id: 'core',
  state: (): GlobalState => ({
    showDropdown: false,
    showDropdownId: '',
  }),
  actions: {
    setShowDropdown(this: any, payload: DropdownInput) {
      this.showDropdown = payload.status;
      this.showDropdownId = payload.id;
    },
  } as GlobalActions,
});

export type CoreStore = ReturnType<typeof useCoreStore>;
